/**
 * Contact desk — custom UI, submit to HubSpot Forms API.
 */
(function () {
  function makeReference(orderNumber) {
    var raw = String(orderNumber || '').trim().toUpperCase();
    var hashMatch = raw.match(/^#?B0*(\d{3,})$/i);
    if (hashMatch) {
      return '#B' + hashMatch[1];
    }
    if (/^BSK[-–]?\d{3,}$/i.test(raw)) {
      return raw.replace(/[–]/g, '-').replace(/^BSK(?!-)/, 'BSK-');
    }
    var n = Math.floor(1000 + Math.random() * 9000);
    return '#B' + n;
  }

  function showSuccess(root, form) {
    var fields = root.querySelector('[data-contact-desk-fields]');
    var success = root.querySelector('[data-contact-desk-success]');
    var errors = root.querySelector('[data-contact-desk-errors]');
    var refEl = root.querySelector('[data-contact-desk-ref]');
    var orderNumber = '';

    if (form) {
      var data = new FormData(form);
      orderNumber = (data.get('order_number') || '').toString();
    }

    root.classList.add('is-success');

    if (refEl) {
      refEl.textContent = makeReference(orderNumber);
    }
    if (fields) {
      fields.hidden = true;
      fields.setAttribute('hidden', '');
    }
    if (errors) {
      errors.hidden = true;
      errors.innerHTML = '';
    }
    if (success) {
      success.removeAttribute('hidden');
      success.hidden = false;
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try {
        success.focus({ preventScroll: true });
      } catch (e) {}
    }
  }

  function showFormAgain(root) {
    var fields = root.querySelector('[data-contact-desk-fields]');
    var success = root.querySelector('[data-contact-desk-success]');
    var errors = root.querySelector('[data-contact-desk-errors]');
    var form = root.querySelector('[data-contact-desk-form]');

    root.classList.remove('is-success');

    if (success) {
      success.hidden = true;
      success.setAttribute('hidden', '');
    }
    if (errors) {
      errors.hidden = true;
      errors.innerHTML = '';
    }
    if (fields) {
      fields.hidden = false;
      fields.removeAttribute('hidden');
    }
    if (form) {
      form.reset();
      try {
        var first = form.querySelector('input, textarea');
        if (first) first.focus({ preventScroll: true });
      } catch (e) {}
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function showError(root, message) {
    var errors = root.querySelector('[data-contact-desk-errors]');
    if (!errors) {
      window.alert(message || 'Something went wrong. Please try again.');
      return;
    }
    errors.hidden = false;
    errors.removeAttribute('hidden');
    errors.textContent = message || 'Something went wrong. Please try again.';
    errors.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function splitName(fullName) {
    var parts = String(fullName || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) {
      return { firstname: '', lastname: '' };
    }
    if (parts.length === 1) {
      return { firstname: parts[0], lastname: '-' };
    }
    return {
      firstname: parts[0],
      lastname: parts.slice(1).join(' ')
    };
  }

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : undefined;
  }

  function getClientIp() {
    return fetch('https://api.ipify.org?format=json', { method: 'GET' })
      .then(function (response) {
        if (!response.ok) return '';
        return response.json();
      })
      .then(function (body) {
        return (body && body.ip) || '';
      })
      .catch(function () {
        return '';
      });
  }

  function buildHubSpotPayload(form, ipAddress) {
    var data = new FormData(form);
    var names = splitName((data.get('full_name') || '').toString());
    var email = (data.get('email') || '').toString().trim();
    var phone = (data.get('phone') || '').toString().trim();
    var orderNumber = (data.get('order_number') || '').toString().trim();
    var message = (data.get('message') || '').toString().trim();

    var commentParts = [];
    if (orderNumber) commentParts.push('Order number: ' + orderNumber);
    if (message) commentParts.push(message);

    var fields = [
      { name: 'firstname', value: names.firstname },
      { name: 'lastname', value: names.lastname },
      { name: 'email', value: email },
      { name: 'phone', value: phone || 'not provided' },
      {
        name: 'TICKET.subject',
        value: orderNumber ? 'Order ' + orderNumber : 'Contact desk'
      },
      {
        name: 'TICKET.contact_comment',
        value: commentParts.join('\n\n') || 'Contact desk enquiry'
      }
    ];

    if (orderNumber) {
      fields.push({ name: 'order_number', value: orderNumber });
    }

    var hutk = getCookie('hubspotutk');
    var context = {
      pageUri: window.location.href,
      pageName: document.title || 'Contact'
    };
    if (hutk) context.hutk = hutk;
    if (ipAddress) context.ipAddress = ipAddress;

    return { fields: fields, context: context };
  }

  function postHubSpot(root, form) {
    var portalId = root.getAttribute('data-hs-portal');
    var formId = root.getAttribute('data-hs-form');
    if (!portalId || !formId) {
      return Promise.reject(new Error('HubSpot form is not configured.'));
    }

    var endpoint =
      'https://api.hsforms.com/submissions/v3/integration/submit/' +
      encodeURIComponent(portalId) +
      '/' +
      encodeURIComponent(formId);

    return getClientIp().then(function (ipAddress) {
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildHubSpotPayload(form, ipAddress))
      });
    }).then(function (response) {
      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (body) {
          if (!response.ok) {
            var detail =
              (body && body.errors && body.errors[0] && body.errors[0].message) ||
              (body && body.message) ||
              'Something went wrong. Please try again.';
            throw new Error(detail);
          }
          return body;
        });
    });
  }

  function isValidEmail(value) {
    return /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(
      String(value || '').trim()
    );
  }

  function submitDesk(root, form, submitBtn) {
    if (root.dataset.contactDeskSubmitting === 'true') return;

    var emailInput = form.querySelector('[name="email"]');
    if (emailInput && !isValidEmail(emailInput.value)) {
      emailInput.setCustomValidity('Enter a valid email like you@email.com');
      emailInput.reportValidity();
      emailInput.setCustomValidity('');
      return;
    }

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    root.dataset.contactDeskSubmitting = 'true';
    if (submitBtn) submitBtn.disabled = true;

    postHubSpot(root, form)
      .then(function () {
        showSuccess(root, form);
      })
      .catch(function (err) {
        console.error('[Contact desk] submit failed', err);
        showError(root, (err && err.message) || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        root.dataset.contactDeskSubmitting = 'false';
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function bindRoot(root) {
    if (!root || root.dataset.contactDeskBound === 'true') return;
    root.dataset.contactDeskBound = 'true';

    var form = root.querySelector('[data-contact-desk-form]');
    var submitBtn = root.querySelector('[data-contact-desk-submit]');
    var againBtn = root.querySelector('[data-contact-desk-again]');
    if (!form) return;

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        submitDesk(root, form, submitBtn);
        return false;
      },
      true
    );

    if (againBtn) {
      againBtn.addEventListener('click', function () {
        showFormAgain(root);
      });
    }
  }

  function bindAll() {
    document.querySelectorAll('[data-contact-desk-root]').forEach(bindRoot);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var root = form.closest('[data-contact-desk-root]');
      if (!root) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      bindRoot(root);
      submitDesk(root, form, root.querySelector('[data-contact-desk-submit]'));
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-contact-desk-root]').forEach(function (root) {
      root.dataset.contactDeskBound = 'false';
    });
    bindAll();
  });
})();
